import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'



const TecSProductMain = () => {


  useEffect(()=>{

    document.getElementById('tec-sectionMain').style.display = "none";
    setTimeout(()=>{
    document.getElementById('tec-sectionMain').style.display = "block";
 
  },1000)
  },[])
  return (
    <div className='tec-addmain'>
      
      
   
         <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">PRODUCTS</span></span>
 <div className='tec-addmain-back'>
<Link to="/Tecsection"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
</div></p> 

 {/* <hr></hr> */}
 </div>
    </div>    


    <ul id="tecLableSection">
  <li className="tecdot tecdottyProduct1"id="tec-lableMainA"></li>
  
  </ul>
  <ul id='tec-sectionMain'>

<li className='tectitle1 tectitle-animate' id="tec-touchMainA"><Link to="/TecProduct"> Product</Link></li>




 </ul>
   
     <div>
    
  
        </div>
  


        </div>
  )
}

export default TecSProductMain
